import { LinearGradient } from "expo-linear-gradient";
import { Box, Stack, VStack } from "native-base";
import React from "react";
import { createShimmerPlaceholder } from "react-native-shimmer-placeholder";
import styled from "styled-components/native";

const ShimmerPlaceholder = createShimmerPlaceholder(LinearGradient);

const ProductLoading = () => {
  return (
    <Stack
      direction={{
        base: "column",
        lg: "row",
      }}
      w="full"
      h="600px"
      bgColor="white.50"
      space="4"
      p="2">
      <Box
        w={{
          base: "full",
          lg: "1/2",
        }}
        rounded="lg">
        <Loader height={300} />
      </Box>
      <VStack
        w={{
          base: "full",
          lg: "1/2",
        }}
        justifyContent="space-between">
        <Box rounded="md" pt="0" py="2">
          <Loader height={60} />
        </Box>
        <Box rounded="md" py="2">
          <Loader height={40} />
        </Box>
        <Box rounded="md" py="2">
          <Loader height={20} />
        </Box>
        <Box rounded="md" py="2">
          <Loader height={30} />
        </Box>
        <Box rounded="md" py="2">
          <Loader height={40} />
        </Box>
        <Box rounded="md" py="2">
          <Loader height={40} />
        </Box>
      </VStack>
    </Stack>
  );
};

const Loader = styled(ShimmerPlaceholder)`
  width: ${({ width }) => (width ? width + "px" : "100%")};
  height: ${({ height }) => (height ? height + "px" : "100%")};
`;

export default ProductLoading;
